import { CartStatusState } from 'b2b-apps/shop/cart/redux/cartStatus/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { CartStatusType } from 'b2b-common/core/cart/api/CartTypes';

const getState = (state: State): CartStatusState => state.cart.cartStatus;

const getCartStatus = (state: State): RemoteRecord<CartStatusType> => new RemoteRecord(getState(state));

const getCartStatusData = (state: State): CartStatusType => {
  const record = getCartStatus(state);

  if (record.data) {
    return record.data;
  }

  return {
    count: 0,
    lastInsertedQuantity: null,
    messages: [],
    value: 0,
    isLastInsertedNewItem: false,
  };
};

const getCartStatusHash = (state: State): string => {
  const { count, value } = getCartStatusData(state);

  return [count, value].join('/');
};

export {
  getCartStatus,
  getCartStatusData,
  getCartStatusHash,
  getState,
};
